import { Helmet } from 'react-helmet';
import { SystemFlagsContainer } from '../components/system-flags.container';


interface ISConfigSystemFlagsProps {}

export const ISConfigSystemFlags: React.FC<ISConfigSystemFlagsProps> = () => {
  return (
    <>
      <Helmet>
      <title>IS Config - System Flags</title>
      </Helmet>
      <SystemFlagsContainer />
    </>
  );
};
